import { render } from "./Language.vue?vue&type=template&id=4128c234&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=4128c234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4128c234"]])

export default __exports__